import TableOfContents from './table-of-contents';

export default TableOfContents;
